import { Loader } from '@shared-ui/components/ui/loader'
import { useAppTheme } from '@shared-ui/theme'
import { StyleSheet, View } from 'react-native'

// Кроет скролл-контейнер базовым фоном с лоадером, пока доводится позиция — рывок не виден.
export function ScrollRestorationOverlay({ isVisible }: { isVisible: boolean }) {
  const theme = useAppTheme()

  if (!isVisible) return null

  return (
    <View
      style={[StyleSheet.absoluteFill, styles.overlay, { backgroundColor: theme.COLOR_BG_BASE }]}
      pointerEvents="none"
    >
      <Loader />
    </View>
  )
}

const styles = StyleSheet.create({
  overlay: {
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  },
})
